import React from 'react';
import { observer, inject } from 'mobx-react';

import { Link } from 'react-router-dom';
import CommonHeader from './HeaderPackage';

import { formatName } from '../../../../common/utilities/name-util';

const Header = ({
  userStore,
  languageStore,
  inboxStore,
  hideNav,
  onboardingStore,
  hidden,
  AIConversationStore: { hasGenAIAnimationLoaded },
}) => {
  const { user } = userStore;
  const { lang } = languageStore;
  const {
    totalNotificationsInboxCount,
    hasNewCertificationFeedback,
  } = inboxStore;

  return (
    <CommonHeader
      hidden={hidden}
      lang={lang}
      totalNotificationsInboxCount={totalNotificationsInboxCount}
      hasNewCertificationFeedback={hasNewCertificationFeedback}
      firstName={formatName(user)}
      routingComponent={Link}
      isCoach={userStore.isCoach}
      hideNav={hideNav}
      user={user}
      userStore={userStore}
      onboardingStore={onboardingStore}
      inboxStore={inboxStore}
      hasGenAIAnimationLoaded={hasGenAIAnimationLoaded}
    />
  );
};

export default inject(
  'userStore',
  'onboardingStore',
  'languageStore',
  'inboxStore',
  'AIConversationStore',
)(observer(Header));
